import React, { useCallback, useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import AppBar         from '@material-ui/core/AppBar';
import Button         from '@material-ui/core/Button';
import Divider        from '@material-ui/core/Divider';
import Drawer         from '@material-ui/core/Drawer';
import FormControl    from '@material-ui/core/FormControl';
import IconButton     from '@material-ui/core/IconButton';
import List           from '@material-ui/core/List';
import ListItem       from '@material-ui/core/ListItem';
import ListItemIcon   from '@material-ui/core/ListItemIcon';
import ListItemText   from '@material-ui/core/ListItemText';
import MenuItem       from '@material-ui/core/MenuItem';
import Select         from '@material-ui/core/Select';
import Snackbar       from '@material-ui/core/Snackbar';
import Toolbar        from '@material-ui/core/Toolbar';

import DescriptionIcon from '@material-ui/icons/Description';
import ExitToAppIcon   from '@material-ui/icons/ExitToApp';
import LabelIcon       from '@material-ui/icons/Label';
import MenuIcon        from '@material-ui/icons/Menu';
import PeopleIcon      from '@material-ui/icons/People';
import ScheduleIcon    from '@material-ui/icons/Schedule';

import './Main.css';

import AttenderMenu from './attender/AttenderMenu';
import Attenders    from './attender/Attenders';
import Reports      from './report/Reports';
import ScheduleMenu from './schedule/Menu';
import Schedules    from './schedule/Schedules';
import Tickets      from './ticket';

const style = {
  main: makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
  })),
  ticketer: makeStyles((theme) => ({
    formControl: {
      color: 'white',
      margin: theme.spacing(1),
      minWidth: 120,
    },
    icon: {
      fill: 'white',
    },
    select: {
      color: 'white',
      lineHeight: 'normal',
    },
  })),
};

function Ticketer(props) {
  const classes = style.ticketer();

  const {
    request,
    setTicketer,
    setTicketers,
    ticketer,
    ticketers,
  } = props.context.getStates();

  const fetchTickers = useCallback(() => {
    request.postSecurely('/ticketers', {}, (response) => {
      if ('error' in response) {
        console.error(response);
      } else if (response.ticketers !== undefined) {
        if (response.ticketers.length > 0 && ticketer === -1) {
          setTicketer(response.ticketers[0].rowid);
        }
        setTicketers(response.ticketers);
      }
    });
  }, [
    request,
    setTicketer,
    setTicketers,
    ticketer,
  ]);

  useEffect(() => {
    fetchTickers();
  }, [fetchTickers]);

  if (ticketers.length > 0 && ticketer > -1) {
    return (
      <FormControl className={classes.formControl}>
        <Select value={ticketer}
          className={classes.select}
          disableUnderline
          inputProps={{
            classes: {
              icon: classes.icon,
            },
          }}
          onChange={(event) => { setTicketer(event.target.value); }}
        >{ticketers.map(ticketer => (
          <MenuItem key={ticketer.rowid}
            value={ticketer.rowid}
          >{ticketer.name}</MenuItem>
        ))}</Select>
      </FormControl>
    );
  } else {
    return null;
  }
}

function Main(props) {
  const classes = style.main();

  const [ drawed, setDrawed ] = useState(false);

  const {
    path,
    setToken,
    setPath,
    setSnackbarMessage,
    snackbarMessage,
  } = props.context.getStates();

  return (
    <div className={classes.root}>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton edge="start" color="inherit"
            onClick={(event) => { setDrawed(true); }}
          ><MenuIcon /></IconButton>

          <Ticketer context={props.context} />

          <span style={{flexGrow: 1}}></span>

          {(
            path === '/attenders' || path === '/attenders#new-attender'
          ) && <AttenderMenu context={props.context} />}
          {path.startsWith('/schedules') && <ScheduleMenu context={props.context} />}
        </Toolbar>
      </AppBar>

      <Drawer anchor={'left'} open={drawed}
        onClose={(event) => { setDrawed(false); }}
      >
        <div role="presentation"
          onClick={(event) => { setDrawed(false); }}
          onKeyDown={(event) => { setDrawed(false); }}
        >
          <List>
            <ListItem button onClick={(event) => { setPath('/tickets'); }} >
              <ListItemIcon><LabelIcon /></ListItemIcon>
              <ListItemText primary={'티켓'} />
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem button onClick={(event) => { setPath('/attenders'); }} >
              <ListItemIcon><PeopleIcon /></ListItemIcon>
              <ListItemText primary={'회원'} />
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem button onClick={(event) => { setPath('/schedules'); }} >
              <ListItemIcon><ScheduleIcon /></ListItemIcon>
              <ListItemText primary={'일정'} />
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem button onClick={(event) => { setPath('/reports'); }} >
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary={'보고서'} />
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem button onClick={(event) => { setToken({access: '', refresh: ''}); }} >
              <ListItemIcon><ExitToAppIcon /></ListItemIcon>
              <ListItemText primary={'로그아웃'} />
            </ListItem>
          </List>
        </div>
      </Drawer>

      <Attenders context={props.context} />

      <Tickets context={props.context} />

      <Reports context={props.context} />

      <Schedules context={props.context} />

      <Snackbar anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        autoHideDuration={3000}
        onClose={(event, reason) => { setSnackbarMessage(''); }}
        open={snackbarMessage !== ''}
        message={snackbarMessage}
        action={
          <React.Fragment>
            <Button size="small" color="secondary"
              onClick={(event, reason) => { setSnackbarMessage(''); }}
            >{'확인'}</Button>
            {/* <IconButton size="small" aria-label="close" color="inherit"
              onClick={(event, reason) => { setSnackbarMessage(''); }}
            ><CloseIcon fontSize="small" /></IconButton> */}
          </React.Fragment>
        }
      />
    </div>
  );
}

export default Main;
